import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { finalize, Subscription } from 'rxjs';
import { COLLEGE_RECON_CONSTANTS, ADMIN_USERS } from 'src/app/constants';
import { StudentService } from 'src/app/services';
import { AuthService, BrowserService, CryptoService } from 'src/app/core';
import { DataService } from 'src/app/services/data-link.service';
import { storageUtil } from 'src/app/utils';
import { cacheBustUrl } from 'src/app/utils/cache-bust-url.util';

@Component({
  selector: 'sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit, OnDestroy {
  user: any;
  items: MenuItem[] = [];
  private veteranInfoSubscription$!: Subscription;
  studentData: any;
  isBrowser: any;
  blurPfp: boolean = false;
  pfppath: string = '';
  pfpext: string = '';
  pfpWidth!: number;
  pfpHeight!: number;
  pfpSize: string = '';
  pfpImage: any;
  isPfpEdit: boolean = false;


  @ViewChild('pfpElement') pfpElement: ElementRef<HTMLImageElement> | undefined;


  constructor(
    private _storageUtil: storageUtil,
    private _cryptoService: CryptoService,
    private _dataService: DataService,
    private _browserService: BrowserService,
    private _authService: AuthService,
    private _studentService: StudentService,
  ) {
    this.setMenuItems();
  }

  ngOnInit() {
    this.isBrowser = this._browserService.checkBrowser();
    if (this.isBrowser) {
      const encryptedData = this._storageUtil.getItem('loggedInUser');
      this.user =
        encryptedData &&
        this._cryptoService.decryptData(
          encryptedData,
          COLLEGE_RECON_CONSTANTS.userEncryptDecryptSecretKey,
        );
      this.user = JSON.parse(this.user);
      this.veteranInfoSubscription$ =
        this._dataService.currentVeteranInfo$.subscribe((veteranInfo: any) => {
          this.studentData = veteranInfo;
          this.pfpImage = cacheBustUrl(this.studentData?.profileImage);
        });

      this.setMenuItems();

    }
  }

  ngOnDestroy(): void {
    this.veteranInfoSubscription$.unsubscribe();
  }

  setMenuItems() {
    this.items = [
      // Veteran Menu Items
      {
        label: 'Dashboard',
        icon: 'pi pi-th-large',
        routerLink: ['/student/dashboard'],
        visible: this.user && this.user.type === 'user' ? true : false,
      },
      {
        label: 'Profile',
        icon: 'pi pi-user',
        routerLink: ['/student/profile'],
        visible: this.user && this.user.type === 'user' ? true : false,
      },
      {
        label: 'Education',
        icon: 'pi pi-book',
        routerLink: ['/student/education'],
        visible: this.user && this.user.type === 'user' ? true : false,
      },
      {
        label: 'Employment',
        icon: 'pi pi-briefcase',
        routerLink: ['/student/employment'],
        visible: this.user && this.user.type === 'user' ? true : false,
      },
      {
        label: 'Benefits',
        icon: 'pi pi-star',
        routerLink: ['/student/benefits'],
        visible: this.user && this.user.type === 'user' ? true : false,
      },
      {
        label: 'Discounts',
        icon: 'pi pi-tag',
        routerLink: ['/student/discounts'],
        visible: this.user && this.user.type === 'user' ? true : false,
      },
      // {
      //   label: 'My Reviews',
      //   icon: 'pi pi-star',
      //   routerLink: ['/student/my-reviews'],
      //   visible: this.user && this.user.type === 'user' ? true : false,
      // },
      {
        visible: this.user && this.user.type === 'user' ? true : false,
      }, {
        visible: this.user && this.user.type === 'user' ? true : false,
      }, {
        visible: this.user && this.user.type === 'user' ? true : false,
      }, {
        visible: this.user && this.user.type === 'user' ? true : false,
      }, {
        visible: this.user && this.user.type === 'user' ? true : false,
      },
      // {
      //   label: 'Help & Support',
      //   icon: 'pi pi-info-circle',
      //   visible: this.user && this.user.type === 'user' ? true : false,
      // },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => this._authService.logout(this.isBrowser),
        visible: this.user && this.user.type === 'user' ? true : false,
      },

      // College Admin Menu Items
      {
        label: 'Reports',
        icon: 'pi pi-th-large',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,

        expanded: true,
        // expanded: true,
      },
      {
        label: 'Activity Report',
        icon: 'pi pi-chart-bar',
        routerLink: ['/college/reports/activity'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'School Data',
        icon: 'pi pi-chart-bar',
        routerLink: ['/college/reports/school-data'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Campaigns',
        icon: 'pi pi-chart-bar',
        routerLink: ['/college/reports/campaigns'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: ' Non-Paid v Campaigns',
        icon: 'pi pi-chart-bar',
        routerLink: ['/college/reports/paid-vs-non-paid'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Platform Data',
        icon: 'pi pi-chart-bar',
        routerLink: ['/college/reports/platform-data'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Inbox',
        icon: 'pi pi-inbox',
        routerLink: ['/college/inbox'],
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false

      },
      {
        label: 'Profile',
        icon: 'pi pi-building',
        // expanded: true,
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
        expanded: true,
      },
      {
        label: 'Overview',
        icon: 'pi pi-book',
        routerLink: ['/college/profile/overview'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Military',
        icon: 'pi pi-users',
        routerLink: ['/college/profile/military'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Yellow Ribbon Program',
        icon: 'pi pi-bolt',
        routerLink: ['/college/profile/yellow-ribbon'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Stats',
        icon: 'pi pi-chart-bar',
        routerLink: ['/college/profile/stats'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Degrees',
        icon: 'pi pi-id-card',
        routerLink: ['/college/profile/degrees'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
      {
        label: 'Contact',
        icon: 'pi pi-phone',
        routerLink: ['/college/profile/contact'],
        styleClass: 'pl-4',
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },

      {
        label: 'Settings',
        icon: 'pi pi-cog',
        routerLink: ['/college/settings'],
        visible: this.user && ADMIN_USERS.includes(this.user.type) ? true : false,
      },
    ];
  }

  pfpHover() {
    this.blurPfp = !this.blurPfp;
  }

  uploadVeteranPfp(event: any) {
    let thisel = this;
    if (this.pfpElement) {
      if (event) {
        let reader = new FileReader();

        const file = event.target.files[0];
        if (file) {
          let pname = file.name;
          const sdata = pname.split(".");
          this.pfpSize = file.size;
          this.pfpext = sdata[sdata.length - 1];
          let extArray = ["png", "jpeg", "jpg"];
          if (!extArray.includes(this.pfpext)) {
            alert("invalid Image Format");
            this.pfpImage = cacheBustUrl(this.studentData.profileImage);
            // this._messageService.add({
            //   severity: 'error',
            //   summary: 'Error',
            //   detail: 'Invalid Image Format',
            // });
          } else {
            reader.readAsDataURL(file);
            reader.onload = (e: any) => {
              const img = new Image();
              img.src = reader.result as string;
              img.onload = () => {
                thisel.pfpWidth = img.width;
                thisel.pfpHeight = img.height;
              };
              let src = e.target.result;
              this.pfpImage = src;
              this.pfppath = e.target.result;
              this.isPfpEdit = true;
            };
          }
        }
      } else {
        console.error('Image element is not available.');
      }
    }

  }

 uploading = false;
  saveVeteranPfp() {
    let veteranProfileImage = {
      fileExtension: this.pfpext,
      imagePath: this.pfpImage,
      uuid: this.studentData.uuid,
    };
    this.uploading = true;
    this._studentService
      .uploadVeteranImage(veteranProfileImage)
      .pipe(finalize(() => (this.uploading = false)))
      .subscribe({
        next: () => {},
        error: (e: any) => {
          console.error(e);
        },
        complete: () => {
          this.isPfpEdit = false;
        },
      });
  }

  cancelPfpUpload() {
    this.isPfpEdit = false;
    this.pfpImage = cacheBustUrl(this.studentData?.profileImage);
  }



}